export default "__VITE_ASSET__b7ca1ce6__"